import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { api } from "@/lib/api";
import { Lock } from "lucide-react";

const TAG_COLORS = {
  structure: "hsl(var(--gold))",
  strategy: "hsl(var(--status-live))",
  risk: "hsl(var(--status-closed))",
  market: "hsl(var(--chart-2))",
};

export default function Intelligence() {
  const [memos, setMemos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/intelligence").then((r) => setMemos(r.data));
  }, []);

  return (
    <DashboardLayout>
      <div className="border-b border-border px-6 md:px-10 py-6">
        <div className="overline gold-text">Research</div>
        <h1 className="font-display font-medium text-3xl md:text-4xl tracking-tight mt-1">Intelligence Memos</h1>
        <p className="text-sm text-muted-foreground mt-2 max-w-xl">
          Weekly deep-dives on structuring, pricing and market dynamics — written by practitioners, not analysts.
        </p>
      </div>

      <div className="px-6 md:px-10 py-8 space-y-3">
        {memos.map((m) => (
          <button
            key={m.id}
            onClick={() => navigate(`/intelligence/${m.id}`)}
            className="card-institutional p-6 w-full text-left block"
            data-testid={`memo-card-${m.id}`}
          >
            <div className="flex items-center gap-3 mb-3">
              <span
                className="text-xs font-medium px-2.5 py-0.5 rounded-full capitalize"
                style={{ color: TAG_COLORS[m.tag] || "hsl(var(--gold))", backgroundColor: `${TAG_COLORS[m.tag] || "hsl(var(--gold))"}20` }}
              >
                {m.tag}
              </span>
              <span className="text-xs text-muted-foreground font-mono">{m.read_time}</span>
              {m.tier_required !== "standard" && <Lock className="h-3 w-3 text-muted-foreground" />}
              <span className="text-xs text-muted-foreground ml-auto font-mono">
                {new Date(m.published_at).toLocaleDateString()}
              </span>
            </div>
            <h2 className="font-display font-medium text-xl md:text-2xl tracking-tight">{m.title}</h2>
            <p className="text-sm text-muted-foreground mt-2">{m.subtitle}</p>
          </button>
        ))}
      </div>
    </DashboardLayout>
  );
}
